import React, { useEffect, useState } from "react";
import UploadMediaonly from "../upload-imageonly";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../Loading";
import { toast } from "react-toastify";
import {
  GetPaymentMethods,
  GetSelectedMethods,
  updatePaymentModes,
} from "../../API  Functions/CashierSetup";
import {
  GetRetailerDetails,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import { uploadImage } from "../../API  Functions/InventoryFunctions";
import { createRoot } from "react-dom/client";
import InventoryOnboardPopup from "../../Popups/InventoryOnboardPopup";
import { checkPermission } from "../../Utils/permissionHelper";
import { Input } from "antd";
import FlagIcon from "../../assets/egypt.svg";

const BasicCashierSettings = ({ retailerDetails }) => {
  const { t, i18n } = useTranslation();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const [base64Images, setBase64Images] = useState();
  const [hasChanges, setHasChanges] = useState(false);
  const [isFileValid, setIsFileValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const [allMethods, setAllMethods] = useState([]);
  const [selectedMethods, setSelectedMethods] = useState([]);
  // const [retailerDetails, setRetailerDetails] = useState({});
  const [customMessage, setCustomMessage] = useState("");
  const [customPhoneNumber, setCustomPhoneNumber] = useState("");
  const [showSalesmanName, setShowSalesmanName] = useState(false);
  const [imageLink, setImageLink] = useState("");
  console.log(
    "retailerDetails?.pos_receipt_custom_msg",
    retailerDetails?.pos_receipt_custom_msg,
  );

  useEffect(() => {
    setCustomMessage(
      retailerDetails?.pos_receipt_custom_msg
        ? retailerDetails?.pos_receipt_custom_msg
        : "",
    );
    setCustomPhoneNumber(
      retailerDetails?.receipt_mobile_number
        ? retailerDetails?.receipt_mobile_number
        : "",
    );
    setShowSalesmanName(retailerDetails?.show_salesman)
    setImageLink(retailerDetails?.logo);
    // fetchdetails();
    GetMethods();
    // GetSelectedMtdts();
  }, [retailerDetails]);

  // const fetchdetails = () => {
  //   GetRetailerDetails(user_id).then((result) => {
  //     if (result) {
  //       setCustomMessage(
  //         result?.retailer_details?.pos_receipt_custom_msg
  //           ? result?.retailer_details?.pos_receipt_custom_msg
  //           : ""
  //       );
  //       setImageLink(result?.retailer_details?.logo);
  //       setRetailerDetails(result?.retailer_details);
  //     }
  //   });
  // };

  const GetMethods = async () => {
    try {
      const res1 = await GetPaymentMethods({ user_id });
      if (res1?.result[0].status_code == 200) {
        setAllMethods(res1?.result[0].response);
        const activeOptions = res1?.result[0].response?.filter(
          (item) => item?.active === true,
        );
        setSelectedMethods(activeOptions);
      } else {
        setAllMethods([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };

  const UpdatePaymentMethods = async () => {
    const payload = {
      user_id: user_id,
      store_id: company_id,
      payment_methods: selectedMethods?.map((method) => method.id), // Only IDs
    };
    try {
      const res1 = await updatePaymentModes(payload);
      if (res1?.result[0]?.status_code == 200) {
        showModal("");
        setHasChanges(false);
      }
      console.log("UpdatePaymentMethods", res1);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const UpdateRetailerData = async () => {
    try {
      let uploadedImageUrl = "";

      // If there's a base64 image, upload it
      if (base64Images) {
        uploadedImageUrl = await uploadImage(company_id, base64Images);
      }
      let phoneNumber = customPhoneNumber?.replace(/^0+/, "");

      const apipayload = {
        store_id: company_id,
        user_id: user_id,
        pos_receipt_custom_msg: customMessage == '' ? false : customMessage,
        show_salesman: showSalesmanName,
        receipt_mobile_number: phoneNumber == '' ? false : phoneNumber,
        ...(uploadedImageUrl != "" && { image_url: uploadedImageUrl }),
      };
      const response = await UpdateRetailerDetails(apipayload);
      console.log("AAAA", response);
      if (response?.status === "Update Successfully") {
        // showModal("");
        setHasChanges(false);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const UpdateData = () => {
    let phoneNumber = customPhoneNumber?.replace(/^0+/, "");

    if (phoneNumber != "" && phoneNumber?.length < 10) {
      toast.error(t("Phone number should have atleast 10 digits"));
      return;
    }

    if (selectedMethods?.length < 1) {
      toast.error(t("Add atleast one Payment Method"));
      return;
    }
    setLoading(true);
    UpdateRetailerData();
    UpdatePaymentMethods();
  };

  const togglePaymentMethod = (methodObj) => {
    setSelectedMethods((prev) => {
      const exists = prev.some((item) => item.id === methodObj.id);
      return exists
        ? prev.filter((item) => item.id !== methodObj.id)
        : [...prev, methodObj];
    });
    setHasChanges(true);
  };

  const getMaxLength = (mobile) => {
    return mobile?.startsWith("0") ? 11 : 10;
  };

  const messages = [
    "Thank you for your order! We appreciate your business.",
    "شكرًا لطلبك! نحن نقدر تعاملَك معنا.",
    "Your order has been placed successfully. Thank you!",
    "تم تقديم طلبك بنجاح. شكرًا لك!",
  ];

  let modalRoot = null; // shared state to track modal status
  let modalContainer = null;

  const showModal = (message) => {
    if (modalRoot) return; // Modal already open

    modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);
    modalRoot = createRoot(modalContainer);

    const handleClose = () => {
      modalRoot.unmount();
      document.body.removeChild(modalContainer);
      modalRoot = null;
      modalContainer = null;
    };

    modalRoot.render(
      <InventoryOnboardPopup message={message} onClose={handleClose} />,
    );
  };

  return (
    <div>
      {loading && <LoadingSpinner />}
      {retailerDetails?.status == "approved" ? (
        <div className=" mb-14 mt-4  mx-4">
          {/* <div className="flex justify-between items-baseline">
          <div className="font-extrabold">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: (
                    <Link to={routes.cashiersetup}>{t("Cashier Setup")}</Link>
                  ),
                  key: "dashboard",
                },
                { title: t("Basic Settings") },
              ]}
              className="relative mt-3 font-semibold"
            />
          </div>
        </div> */}
          <div className="flex gap-5 mt-5  justify-end">
            <button
              // onClick={UpdateData}
              onClick={() => {
                if (checkPermission("/settings/cashiersetup", isGinne)) {
                  UpdateData();
                }
              }}
              className={`w-36 h-10 rounded-lg font-semibold ${
                hasChanges
                  ? "bg-primaryBlue text-white"
                  : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
              }`}
              disabled={!hasChanges}
            >
              {t("save")}
            </button>
          </div>
          <div className="md:w-full min-h-auto bg-[#FFFFFF] border border-b-0 rounded-tr-xl rounded-tl-xl mt-5">
            <div className="w-full h-10 bg-[#C9ECF7] px-4  flex items-center font-medium text-base rounded-tr-xl rounded-tl-xl text-[#272728]">
              {t("Payment Methods")}
            </div>
            <div className="flex flex-wrap mx-10 pb-4 pt-4">
              {allMethods.map((paymentMethod) => {
                const isSelected = selectedMethods?.some(
                  (item) => item.id === paymentMethod.id,
                );
                return (
                  <div key={paymentMethod.id} className="w-1/4 px-3 pb-2">
                    <div
                      className={`flex items-center h-14 justify-center gap-2 mt-2 px-8 py-2 text-l  rounded-lg border shadow-sm cursor-pointer ${
                        isSelected
                          ? "text-white font-extrabold bg-blue-900"
                          : "bg-white border font-medium border-[#C6C6C6] text-zinc-600"
                      }`}
                      onClick={() => togglePaymentMethod(paymentMethod)}
                    >
                      <label className=" text-base cursor-pointer">
                        {t(paymentMethod.name)}
                      </label>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* <div className="md:w-full min-h-auto bg-[#FFFFFF] border">
          <div className="w-full h-10 bg-[#C9ECF7] px-4  flex items-center font-medium text-base text-[#272728]">
            {t("Delivery From")}
          </div>
          <div className="flex flex-wrap mx-10 pb-6 pt-4">
            {deliveryOptions.map((option) => {
              const isSelected = selectedDeliveryFrom?.some(
                (item) => item.id === option.id && item.active
              );

              return (
                <div key={option.name} className="w-1/3 px-3">
                  <div
                    className={`flex items-center h-16 justify-center gap-2 mt-2 px-8 py-2 text-l font-semibold rounded-lg border shadow-sm cursor-pointer ${
                      isSelected
                        ? "text-blue-900 bg-[#EBF2FF] border-blue-900"
                        : "bg-white border border-[#C6C6C6] text-zinc-600"
                    }`}
                    onClick={() => toggleDeliveryFrom(option)}
                  >
                    <label className="font-medium text-base cursor-pointer">
                      {t(option.name)}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}

          <div className="md:w-full min-h-auto bg-[#FFFFFF] border">
            <div className="w-full h-10 bg-[#C9ECF7] px-4 flex items-center font-medium text-base text-[#272728]">
              {t("Custom Message For Receipt")}
            </div>
            <div className="mx-6 pb-6 pt-6">
              <div className="flex justify-between items-center flex-wrap w-full gap-4 mb-6">
                {messages.map((msg, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setCustomMessage(msg);
                      setHasChanges(true);
                    }} // 👈 Set text on click
                    className="w-[47%] cursor-pointer text-sm text-body text-center rounded-md border p-3 font-normal hover:bg-gray-100 transition"
                  >
                    {msg}
                  </div>
                ))}
              </div>

              <textarea
                onChange={(e) => {
                  setCustomMessage(e.target.value);
                  setHasChanges(true);
                }}
                placeholder={t("Type something here...")}
                maxLength={100}
                rows={3} // You can adjust the number of visible rows as needed
                className={`w-full text-sm text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md border p-3 font-[inherit] font-normal resize-none `}
                style={{
                  WebkitAppearance: "none",
                  MozAppearance: "textfield",
                }}
                value={customMessage}
              />
              <label className=" text-sm text-[#93989C] font-medium">
                {t("Maximum 100 characters")}
              </label>
            </div>
          </div>

          <div className="md:w-full min-h-auto bg-[#FFFFFF] border rounded-br-xl rounded-bl-xl">
            <div className="w-full h-10 bg-[#C9ECF7] px-4 flex items-center font-medium text-base text-[#272728]">
              {t("Phone Number for Receipt")}
            </div>
            <div className="flex flex-wrap mx-6 pb-6 pt-4">
              <div className="m-2 w-full">
                <div className="flex flex-row">
                  <div className="h-10 w-16 text-md text-body outline-none focus:outline-none  rounded-md border p-3 flex items-center justify-center">
                    <img src={FlagIcon} height={50} width={50} alt="img" />
                  </div>
                  <Input
                    type="tel"
                    placeholder={t("01-xxxxxxxx")}
                    value={customPhoneNumber}
                    onChange={(e) => {
                      const value = e.target.value;

                      // allow empty value (for backspace)
                      if (value === "" || /^[0-9]*$/.test(value)) {
                        setCustomPhoneNumber(e.target.value);
                        setHasChanges(true);
                      }
                    }}
                    //       onChange={(e) => {
                    //        setCustomPhoneNumber(e.target.value);
                    // setHasChanges(true);
                    //       }}
                    // onBlur={formik.handleBlur}
                    // name="phoneNumber"
                    maxLength={getMaxLength(customPhoneNumber)}
                    className={`h-10 w-100 ms-2 text-md text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md border p-3`}
                    // disabled={isEdit?.user_type === "admin"}
                  />
                </div>
              </div>
            </div>
          </div>

           <div className="md:w-full min-h-auto bg-[#FFFFFF] border rounded-br-xl rounded-bl-xl">
            <div className="w-full h-10 bg-[#C9ECF7] px-4 flex items-center font-medium text-base text-[#272728]">
              {t("Show Salesman Name on Recepit")}
            </div>
              <div className=" flex gap-x-2 items-center my-5 ms-6">
            <label className="flex cursor-pointer select-none items-center me-7">
              <div className="relative">
                <input
                  type="checkbox"
                  checked={showSalesmanName}
                  onChange={()=>{
                    setHasChanges(true);
                    setShowSalesmanName(!showSalesmanName)}}
                  className="sr-only"
                />
                <div
                  className={`box block h-6 w-12 rounded-full ${
                    showSalesmanName
                      ? "bg-green-500"
                      : "bg-gray-500"
                  }`}
                ></div>
                <div
                  className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
                    showSalesmanName
                      ? "translate-x-full"
                      : ""
                  }`}
                ></div>
              </div>
            </label>
          </div>
          </div>

          
          <div className="md:w-full min-h-auto bg-[#FFFFFF] border rounded-br-xl rounded-bl-xl">
            <div className="w-full h-10 bg-[#C9ECF7] px-4 flex items-center font-medium text-base text-[#272728]">
              {t("Upload Shop Logo")}
            </div>
            <div className="flex flex-wrap mx-6 pb-6 pt-4">
              <div className="m-2 w-full">
                <span
                  className={`flex  flex-col border rounded-xl relative  justify-center items-center  py-6`}
                >
                  {base64Images ? (
                    <img
                      src={base64Images}
                      height={100}
                      width={100}
                      alt="prod"
                      style={{
                        minWidth: "17rem",
                        maxWidth: "18rem",
                        maxHeight: "13rem",
                        minHeight: "12rem",
                        marginBottom: 10,
                      }}
                    />
                  ) : (
                    imageLink && (
                      <img
                        src={`${imageLink}?t=${Date.now()}`}
                        height={100}
                        width={100}
                        alt="Uploaded"
                        style={{
                          minWidth: "17rem",
                          maxWidth: "18rem",
                          maxHeight: "13rem",
                          minHeight: "12rem",
                          marginBottom: 10,
                        }}
                      />
                    )
                  )}
                  <span className="cursor-pointer">
                    <UploadMediaonly
                      foldername={"store_image"}
                      onfileAdd={"Productrequest"}
                      setBase64Images={(data) => {
                        setBase64Images(data);
                        setHasChanges(true);
                      }}
                      urlgenerated={(val) => setImageLink(val?.url)}
                      imageurl={imageLink == undefined ? "" : imageLink}
                      setIsFileValid={setIsFileValid}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
          {/* <div className="flex gap-5 mt-5  justify-end">
            <button
              // onClick={() => onClose()}
              className="w-36 h-10 bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
            >
              {t("cancel")}
            </button>
            <button
              onClick={UpdateData}
              className={`w-36 h-10 rounded-lg font-semibold ${
                hasChanges
                  ? "bg-primaryBlue text-white"
                  : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
              }`}
              disabled={!hasChanges}
            >
              {t("save")}
            </button>
          </div> */}
        </div>
      ) : (
        <>
          <div className="flex justify-center w-full mt-16 text-base text-body text-center p-3 font-normal ">
            {retailerDetails?.status && retailerDetails?.status != "approved"
              ? t(
                  "You cannot update cashier settings until your store is approved by myGINNE.",
                )
              : ""}
          </div>
        </>
      )}
    </div>
  );
};

export default BasicCashierSettings;
